import { useState, useEffect } from 'react';
import Reviews from '../Reviews';
import CustomReviews from '../CustomReviews';

const CtaBanner = ({ content, customReviewsData }) => {
  const placeholder_mobile = '/images/cta-banner-image-mobile.webp';
  const placeholder_desktop = '/images/cta-banner-image.webp';
  const [width, setWidth] = useState([]);
  const { sourceUrl: desktopImage } = content.desktopBackground ? content.desktopBackground : '';
  const { sourceUrl: mobileImage } = content.mobileBackground ? content.mobileBackground : '';
  const { displayOption, buttonLink } = content;
  const ctaButtonLink = buttonLink ? buttonLink : '/contact-us';
  const displayBlock = displayOption === 'enable';

  useEffect(() => {
    setWidth(window.innerWidth);
  }, [setWidth]);

  const desktop = width > 767;

  return (
    displayBlock && (
      <div className="cta">
        <div className="cta-banner description_class">
          <div className="cta-banner__container ">
            <h6>Do I Have a Case?</h6>
            <p>
              Get an instant, free Case Analysis with strengths, weaknesses and next steps. From our
              award winning Monaco Solicitors AI.
            </p>
            <a href="/do-i-have-a-case" className="button">
              Get Started
            </a>
            <div className="cta-banner__review__section">
              <CustomReviews customReviewsData={customReviewsData} />
            </div>
            <Reviews isFromPage classNames="reviews--transparent" />
          </div>
        </div>
        <div className="cta-review">
          <Reviews isFromPage classNames="reviews--transparent">
            <h3>
              Rated 4.8 Stars in Over 1,000 <a href="/testimonials">Reviews</a>
            </h3>
          </Reviews>
        </div>
      </div>
    )
  );
};

export default CtaBanner;
